import { dateUtils } from '@/utils'
import { getDay } from 'date-fns/esm'
import { RecurrenceSettingsState } from '../../../types'

export function updateRecurrenceDate(
  state: RecurrenceSettingsState,
  recurrenceDate: Date,
): RecurrenceSettingsState {
  const updatedState = {
    ...state,
    value: {
      ...state.value,
      recurrencePeriod: {
        ...state.value.recurrencePeriod,
        date: dateUtils.convertToYYYYMMDD(recurrenceDate),
        cardinal: undefined,
        weekday: undefined,
        month: undefined,
      },
    },
  }

  const weekday =
    updatedState.value.recurrencePeriod.recurrenceType === 'WEEKLY'
      ? (getDay(
          dateUtils.parseDate(updatedState.value.recurrencePeriod.date),
        ) as uui.domain.client.rm.WeekDay)
      : undefined

  const recurrencePeriod = { ...updatedState.value.recurrencePeriod, weekday }

  return {
    ...updatedState,
    value: {
      ...updatedState.value,
      recurrencePeriod,
    },
  }
}
